import './App.scss';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SpinnerComponent from './components/spinner/spinner.component';
import HeaderComponent from './routes/layout/components/header.component';
import { AppLogoComponent } from './routes/layout/components/logo/app-logo.component';
import MainContainerComponent from './routes/layout/components/main-container/main-container.component';

import NavigationTopPublicBarComponent from './routes/layout/components/navigation/navigation-top-public-bar.component';
import {
  leftMenuList,
  rightMenuList,
} from './static-resources/static-navigation';

function AppPublic() {
  return (
    <>
      <HeaderComponent logo={<AppLogoComponent />}>
        <NavigationTopPublicBarComponent
          leftMenuList={leftMenuList}
          rightMenuList={rightMenuList}
        />
      </HeaderComponent>
      <MainContainerComponent>
        <Suspense fallback={<SpinnerComponent />}>
          <Outlet />
        </Suspense>
      </MainContainerComponent>
    </>
  );
}

export default AppPublic;
